// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"633":"65bc3d03","685":"23b9ebc6","906":"4f8dea6c"}[chunkId] + ".chunk.js";
};